import {createSelector} from 'reselect';
import {getOrderTotalNumeric} from '../../OrderSummarySelectors';
import {getSettings} from '../../selectors';

export default createSelector(
  [getSettings, getOrderTotalNumeric],
  (settings, orderTotal) => !!(orderTotal < settings?.klarna_min_value
    || orderTotal > settings?.klarna_max_value),
);
